import {Injectable} from '@angular/core';
import {AssessmentService} from './assessment.service';

@Injectable()
export class ActionPlanningTableService {
    constructor(private assessmentService: AssessmentService) {}

    getNeeds3Array(assessment, actionPlanningItems) {
        const ret = [];
        if (assessment.type && actionPlanningItems[assessment.type]) {
            actionPlanningItems[assessment.type].needs.forEach((questionIdentifier) => {
                const question = this.assessmentService.getQuestionByIdentifier(assessment, questionIdentifier);
                if (question && question.a && question.a[0] === '3') {
                    ret.push({
                        'identifier': question.identifier
                        , 'text': question.text
                        , 'excluded': false
                    });
                }
            });
        }
        return ret;
    }

    getNeeds2Array(assessment, actionPlanningItems) {
        const ret = [];
        if (assessment.type && actionPlanningItems[assessment.type]) {
            actionPlanningItems[assessment.type].needs.forEach((questionIdentifier) => {
                const question = this.assessmentService.getQuestionByIdentifier(assessment, questionIdentifier);
                if (question && question.a && question.a[0] === '2') {
                    ret.push({
                        'identifier': question.identifier
                        , 'text': question.text
                        , 'excluded': false
                    });
                }
            });
        }
        return ret;
    }

    getStrengths23Array(assessment, actionPlanningItems) {
        const ret = [];
        if (assessment.type && actionPlanningItems[assessment.type]) {
            actionPlanningItems[assessment.type].strengths.forEach((questionIdentifier) => {
                const question = this.assessmentService.getQuestionByIdentifier(assessment, questionIdentifier);
                if (question && question.a && (question.a[0] === '3' || question.a[0] === '2')) {
                    ret.push({
                        'identifier': question.identifier
                        , 'text': question.text
                        , 'excluded': false
                    });
                }
            });
        }
        return ret;
    }

    getStrengths01Array(assessment, actionPlanningItems) {
        const ret = [];
        if (assessment.type && actionPlanningItems[assessment.type]) {
            actionPlanningItems[assessment.type].strengths.forEach((questionIdentifier) => {
                const question = this.assessmentService.getQuestionByIdentifier(assessment, questionIdentifier);
                if (question && question.a && (question.a[0] === '0' || question.a[0] === '1')) {
                    ret.push({
                        'identifier': question.identifier
                        , 'text': question.text
                        , 'excluded': false
                    });
                }
            });
        }
        return ret;
    }

    getTrauma123YArray(assessment, actionPlanningItems) {
        const ret = [];
        if (assessment.type && actionPlanningItems[assessment.type]) {
            actionPlanningItems[assessment.type].trauma.forEach((questionIdentifier) => {
                const question = this.assessmentService.getQuestionByIdentifier(assessment, questionIdentifier);
                if (question && question.a && (question.a[0] === '3' || question.a[0] === '2' || question.a[0] === '1' || question.a[0] === 'Y')) {
                    ret.push({
                        'identifier': question.identifier
                        , 'text': question.text
                        , 'excluded': false
                    });
                }
            });
        }
        return ret;
    }

    modOnExcludedIdentifiers(str, array) {
        array.forEach((item) => {
            if (item.excluded) {
                if (str && str !== '') {
                    str += ',' + item.identifier;
                } else {
                    str = item.identifier;
                }
            }
        });
        return str;
    }
}
